<template>
  <transition name="fade" duration="500">
    <div class="overlay" :class="{ 'd-modal-wrapper': !isMobile }" ref="elem" v-if="modalOpen">
      <div class="d-modal" :class="{ loading: loading }">
        <slot></slot>
      </div>
    </div>
  </transition>
</template>

<script>
import Vue from "vue"
import Header from "./header.vue"
import Main from "./main.vue"
import Footer from "./footer.vue"
import { responsiveHelper } from "../utils/responsive-helper"
import { modalSignals } from "../utils/utils"
import textHelper from "../utils/text-helper"

Vue.component("modal-header", Header)
Vue.component("modal-main", Main)
Vue.component("modal-footer", Footer)

Vue.directive("open-modal", {
  inserted: function (el, binding, vnode) {
    var modal = binding.value
    el.addEventListener("click", function (e) {
      e.preventDefault()
      modalSignals.$emit("toggle", modal, true)
    })
  },
})

Vue.directive("close-modal", {
  inserted: function (el, binding, vnode) {
    var modal = binding.value
    el.addEventListener("click", function (e) {
      e.preventDefault()
      modalSignals.$emit("toggle", modal, false)
    })
  },
})

export default {
  props: ["name", "loading"],
  data: function () {
    return {
      modalOpen: false,
      body: document.querySelector("body"),
      mobileHiddenElements: [],
      mobileHiddenElementsDisplay: [],
      mobileVisibleElements: [],
      isMobile: responsiveHelper.isMobileDevice(),
    }
  },
  mounted: function () {
    var self = this

    modalSignals.$on("toggle", (modal, open) => {
      self.isMobile ? self.handleTogglingModalOnMobileDevices(open, modal) : self.handleTogglingModalOnDesktops(open, modal)
    })
  },
  watch: {
    isMobile(v) {
      console.log("isMobile changed")
      window.location.reload()
    },
  },
  methods: {
    openModal: function () {
      const self = this
      console.log("modal.vue -> openModal")
      if (this.isMobile) {
        console.log("inside isMobile")
        setTimeout(() => {
          self.mobileHiddenElements = []
          self.mobileHiddenElementsDisplay = []
          self.mobileVisibleElements = []
          var el = self.$refs.elem
          var node = []

          do {
            var parent = el.parentElement
            for (let i = 0; i < parent.children.length; i++) {
              node = parent.children[i]
              node !== el ? self.mobileHiddenElements.push(node) : self.mobileVisibleElements.push(node)
            }
            el = parent
          } while (el.tagName.toLowerCase() !== "body")

          self.mobileHiddenElements.forEach(function (item) {
            self.mobileHiddenElementsDisplay.push(item.style.display)
            item.style.display = "none"
          })

          self.mobileVisibleElements.forEach(item => {
            item.style.height = "100vh"
            item.style.margin = 0
            item.style.padding = 0
            if (item.classList[0] === "col-md-8") {
              item.classList.remove("col-md-8")
              item.classList.add("missing-md-8")
            }
            if (item.classList[0] === "col-md-12") {
              item.classList.remove("col-md-12")
              item.classList.add("missing-md-12")
            }
          })
          document.querySelector("#content").style.padding = "0"
          document.querySelectorAll(".section-wrapper").forEach(el => (el.style.paddingTop = "0"))
          document.querySelectorAll(".margin-top").forEach(el => (el.style.marginTop = "0"))
          document.querySelectorAll(".container").forEach(el => (el.style.padding = "0"))
          document.querySelectorAll("section").forEach(el => (el.style.padding = "0"))
        })
        // }, 500)
      }
      this.modalOpen = true
      this.body.classList.add("no-scroll")
      this.$emit("open", this)
    },
    closeModal: function () {
      modalSignals.$emit("toggle", false)
      // if (this.isMobile) {
      //   const self = this;
      //   self.mobileHiddenElements.forEach(function(item, index) {
      //     item.style.display = self.mobileHiddenElementsDisplay[index];
      //   });
      //   self.mobileVisibleElements.forEach(item => {
      //     item.style.height = "100%";
      //     if (item.classList[0] === "missing-md-8") {
      //       item.classList.add("col-md-8");
      //       item.classList.remove("missing-md-8");
      //     }
      //     if (item.classList[0] === "missing-md-12") {
      //       item.classList.add("col-md-12");
      //       item.classList.remove("missing-md-12");
      //     }
      //   });
      //   document.querySelector("#content").style.padding = "40px 15px 15px";
      //   document
      //     .querySelectorAll(".section-wrapper")
      //     .forEach(el => (el.style.paddingTop = "0 1rem"));
      //   document
      //     .querySelectorAll(".margin-top")
      //     .forEach(el => (el.style.marginTop = "5vh"));
      //   document
      //     .querySelectorAll("section")
      //     .forEach(el => (el.style.padding = "2em"));
      //   document
      //     .querySelectorAll(".container")
      //     .forEach(el => (el.style.padding = "1rem"));
      // }

      this.modalOpen = false
      this.body.classList.remove("no-scroll")
      this.$emit("close", this)
    },
    handleTogglingModalOnMobileDevices: function (open, modal) {
      console.log("handleTogglingModalOnMobileDevices() called")
      let element = textHelper.divideTextUsingCapitalLetter(modal).replace(/\s+/g, "-").toLowerCase()
      if (this.name === modal) {
        if (!open) {
          this.closeModal()
          if (element) {
            $("html,body").animate({ scrollTop: $(`.${element}`).offset().top - 200 }, 500)
          }
        } else {
          this.openModal()
        }
      }
    },
    handleTogglingModalOnDesktops: function (open, modal) {
      console.log("handleTogglingModalOnDesktops() called")
      if (this.name === modal) {
        open ? this.openModal() : this.closeModal()
      }
    },
  },
}
</script>

<style lang="scss">
@media screen and (max-width: 767px) {
  .claim-modal .d-modal {
    height: auto;
    width: 100%;
    max-width: initial;
  }
  .d-modal {
    position: relative;
    z-index: 222;
  }
  .d-navbar {
    display: flex !important;
  }
}
.d-modal-wrapper {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  // align-items: center;
  width: 100vw;
  height: 100%;
  background-color: rgba(58, 66, 76, 0.8);
  z-index: 70000;
}

.d-modal {
  background-color: #ffffff;
  max-height: 100%;
  display: flex;
  flex-direction: column;
  width: 100vw;
  max-width: 800px;
  border-radius: 15px;
  // height: 940px;

  @media (max-width: 768px) {
    height: 100vh;
    width: 100%;
    max-width: initial;
  }

  &.loading {
    pointer-events: none;
    opacity: 0.85;
    touch-action: none;
  }
}

.d-modal-close {
  display: none;
  color: #1576bc;
  font-size: 21px;
  position: absolute;
  top: 25px;
  right: 30px;
  cursor: pointer;
  z-index: 5;
  @media screen and (max-width: 900px) {
    top: 60px;
  }
}

.d-modal-header-wrapper {
  position: relative;

  .d-modal-header {
    padding: 20px 60px 20px 30px;
    background-color: #f6f6f6;
    font-size: 22px;
    font-weight: bold;
    border-top-right-radius: 15px;
    border-top-left-radius: 15px;
  }

  &.alternative {
    font-family: Lato;
    .d-modal-header {
      color: #ffffff;
      background-color: #1576bc;

      ~ .d-modal-close {
        color: #ffffff;
      }
    }
  }

  &.white {
    .d-modal-header {
      color: #333333;
      background-color: #ffffff;
      font-size: 22px;
    }
  }

  &.wide {
    .d-modal-header {
      min-height: 130px;
    }
  }
}

.d-modal-main {
  padding: 20px 30px;
  position: relative;
  overflow: hidden;
  // overflow: auto;
  height: calc(100vh - 300px);
  flex: 1 1 auto;
  @media screen and (max-width: 768px) {
    overflow: auto;
    height: calc(100vh - 200px);
  }

  &.center {
    padding: 60px 50px;
    text-align: center;
  }

  &.min-height {
    @media (min-width: 520px) {
      min-height: 535px;
      max-height: 750px;
    }
  }

  &.bottom-padding {
    > div {
      padding-bottom: 50px;
      position: relative;
      min-height: 100%;
    }
  }

  &.auto-height {
    height: auto !important;
  }
}

.d-modal-footer {
  padding: 20px 30px;
  border-top: 2px solid #f6f6f6;
  display: flex;
  justify-content: flex-end;
  font-family: Lato;
  font-weight: bold;
}

.labeled-input {
  font-size: 16px;

  label {
    font-weight: normal;
    color: #6d6d6d;
    line-height: 22px;
    min-height: 1em;
  }
  .bold-text {
    font-weight: bold;
  }

  .error {
    color: #f11b23;
    margin-top: 5px;
    font-size: 14px;
  }

  &.disabled {
    pointer-events: none;

    .autocomplete__box {
      background-color: #eeeeee;
    }
  }
  .input-addon {
    color: #999999;
    margin: 5px 0;
    font-size: 12px;
  }
}

.modal-tabs {
  display: flex;
  width: calc(100% + 60px);
  border-bottom: 1px solid #dddddd;
  margin: 0 -30px;
  margin-bottom: 15px;
  padding: 0 30px;
  overflow-x: auto;
}

.modal-tab-button {
  font-size: 18px;
  color: #6e6e6e;
  margin-right: 15px;
  cursor: pointer;
  margin-bottom: -1px;
  border-bottom: 2px solid transparent;
  padding-bottom: 8px;
  display: flex;
  align-items: center;
  flex: 0 0 auto;

  &.active {
    color: #0f74bd;
    border-color: #0f74bd;
  }
}

.autocomplete {
  img {
    display: block;
  }
}

.form-wrapper {
  // margin: 1.5rem;
  margin: auto;
  max-width: 581px;
  @media screen and (max-width: 600px) {
    margin: 0 0.5rem;
  }
}

.form-input,
.autocomplete__box,
.multiselect__tags {
  &:not(.no-style) {
    padding: 10px 15px !important;
    border: 1px solid #dddddd !important;
    border-radius: 7px !important;
    font-size: 16px !important;
    line-height: 22px !important;
    height: auto !important;

    input:focus {
      box-shadow: none !important;
    }
  }

  &.no-style {
    border: none !important;
  }
}

textarea.form-input {
  resize: none;
}

.modal-photo {
  width: 160px;
  height: 160px;
  border: 1px solid white;
  border-radius: 50%;
  background-color: white;
  background-size: cover;
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 2;
  box-shadow: 0 8px 10px 0px rgba(0, 0, 0, 0.21);
}

.follow-header {
  color: #0f74bd;
  font-size: 24px;
  font-weight: bold;
}

.annotate {
  color: #6d6d6d;
  font-size: 16px;
}

.centered-list {
  max-width: 225px;
  margin: 20px auto 0;
}

.big-padding {
  padding: 0 120px;
}

.big-margin-top {
  margin-top: 70px;
}

.big-padding-top {
  padding-top: 100px;
}

.follow-success {
  color: #6d6d6d;
  font-size: 24px;
  font-weight: bold;
}

.follow-success-icon {
  font-size: 70px;
  color: #21d35a;
  margin-bottom: 5px;
}

.success-main {
  padding: 70px 50px;
}

.success-buttons {
  margin: 60px auto 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.characters-remaining {
  color: #999999;
  font-size: 12px;
  line-height: 22px;
  margin-top: 5px;
}

.select-wrapper {
  position: relative;

  select {
    padding: 0 15px;
    -webkit-appearance: none;
    -moz-appearance: none;
    text-indent: 1px;
    text-overflow: "";
  }

  &:after {
    display: block;
    content: "\f0d7";
    font-family: "Font Awesome\ 5 Free";
    font-size: 18px;
    position: absolute;
    right: 10px;
    top: 11px;
    font-weight: bold;
    color: #0e72ba;
  }
}

.space-between-v {
  display: flex;
  height: 100%;
  flex-direction: column;
  justify-content: space-between;
}

.checkbox-list {
  border: 1px solid #dddddd;
  border-radius: 7px;
}

.checkbox-list-header {
  border-bottom: 1px solid #dddddd;
  padding: 10px 15px;
}

.checkbox-list-body {
  padding: 10px 15px;
}

.import-btn {
  color: #0e72ba;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  cursor: pointer;

  .fa-download {
    font-size: 23px;
    margin-right: 10px;
  }
}

.publication-entry {
  padding: 0 20px 10px;
}

.tab-loading {
  pointer-events: none;
  opacity: 0.8;
}

.main-bottom {
  position: absolute;
  left: 0;
  bottom: 0;
}

.claim-modal {
  .title {
    text-transform: uppercase;
    color: #0f74bd;
    font-size: 24px;
    margin: 10px 0 0;
  }
  .sub-title {
    color: #6d6d6d;
    font-size: 22px;
    font-weight: bold;
    @media screen and (max-width: 768px) {
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
  .sub-info {
    color: #6d6d6d;
    font-size: 18px;
    margin: 0;
    display: block;
  }
  .main-content {
    border-top: 1px solid #0f74bd;
    margin-top: 15px;
    @media screen and (max-width: 768px) {
      margin-top: 10px;
      overflow-y: scroll;
      height: 22vh;
    }
    .static-header {
      text-transform: uppercase;
      background-color: #0f74bd;
      color: #fff;
      border-top: 1px solid #0f74bd;
      width: 280px;
      margin: 0 auto 5px;
      padding: 10px 45px;
    }
    .main-info {
      font-size: 24px;
      color: #6d6d6d;
      margin-top: 30px;
    }
    .perjury {
      color: #6d6d6d;
      font-size: 16px;
      @media screen and (max-width: 768px) {
        font-size: 15px;
      }
    }
  }
  .confirmation-note {
    margin-bottom: 0;
    color: #6d6d6d;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    @media screen and (max-width: 768px) {
      margin-top: 10px;
    }
  }
}

.claim-success-main {
  padding: 90px 40px !important;
}

.claim-success-footer {
  display: flex;
  justify-content: center;
  .success-buttons {
    margin: 0 !important;
    .modal-button {
      min-width: 180px;
    }
  }
}

.d-modal-main.success-main {
  text-align: center;
}

.modal-part {
  height: 100%;

  .d-modal-main.big-margin-top {
    @media (max-width: 768px) {
      height: calc(100% - 220px);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/login/modal/modal.vue